<template>
    <div class="search">
        <!-- <b-input-group>
            <b-form-input v-model="text" placeholder="Try ATMs, Jolibee"></b-form-input>
            <b-form-input v-model="location"></b-form-input>
            <b-input-group-prepend>
                <span class="input-group-text">
                    <b-icon icon="search"></b-icon>
                </span>
            </b-input-group-prepend>
        </b-input-group> -->
        <SearchInputGroup :reloadPage="false" />

        <b-dropdown text="Restaurants" variant="outline">
            <b-dropdown-item href="#"><b-img src="https://i.pinimg.com/originals/7d/bb/51/7dbb51660389a4a6a444bdffa3be0265.png" width="30" alt="Left image"></b-img> Delivery</b-dropdown-item>
            <b-dropdown-item href="#"><b-img src="https://img.icons8.com/pastel-glyph/2x/hamburger.png" width="30" alt="Left image"></b-img> Burgers</b-dropdown-item>
            <b-dropdown-item href="#"><b-img src="https://cdn.iconscout.com/icon/premium/png-256-thumb/chinese-food-1935913-1640779.png" width="30" alt="Left image"></b-img> Chinese</b-dropdown-item>
            <b-dropdown-item href="#"><b-img src="https://cdn1.iconfinder.com/data/icons/bistro-restaurant-part-i/64/bistro-and-restaurant_20-512.png" width="30" alt="Left image"></b-img> Italian</b-dropdown-item>
            <b-dropdown-item href="#"><b-img src="https://cdn4.iconfinder.com/data/icons/pictograms-1/512/Calendar-512.png" width="30" alt="Left image"></b-img> Reservations</b-dropdown-item>
            <b-dropdown-item href="#"><b-img src="https://banner2.cleanpng.com/20180512/yve/kisspng-sushi-japanese-cuisine-teppanyaki-computer-icons-5af6f29b36b3c3.2426753015261334032241.jpg" width="30" alt="Left image"></b-img> Japanese</b-dropdown-item>
            <b-dropdown-item href="#"><b-img src="https://image.flaticon.com/icons/png/512/94/94280.png" width="30" alt="Left image"></b-img> Mexican</b-dropdown-item>
            <b-dropdown-item href="#"><b-img src="https://cdn.iconscout.com/icon/premium/png-256-thumb/shrimp-2052699-1737522.png" width="30" alt="Left image"></b-img> Thai</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Home Services" variant="outline">
            <b-dropdown-item href="#"><b-img src="https://i.pinimg.com/originals/7d/bb/51/7dbb51660389a4a6a444bdffa3be0265.png" width="30" alt="Left image"></b-img> Delivery</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Auto Services" variant="outline">
            <b-dropdown-item href="#"><b-img src="https://i.pinimg.com/originals/7d/bb/51/7dbb51660389a4a6a444bdffa3be0265.png" width="30" alt="Left image"></b-img> Delivery</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="More" variant="outline">
            <b-dropdown-item href="#"><b-img src="https://i.pinimg.com/originals/7d/bb/51/7dbb51660389a4a6a444bdffa3be0265.png" width="30" alt="Left image"></b-img> Delivery</b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<style scoped>
.search {
    /* background-color: lightblue; */
    /* height: 120px; */
    width: 50vw;
    z-index: 500;
    /* position: absolute; */
    top: 10%;
    left: 30%
}

</style>

<script>
import SearchInputGroup from './SearchInputGroup'

export default {
    components:{
        SearchInputGroup
    },
    data() {
        return {
            text: "",
            location: "Manila City, Metro Manila"
        }
    }
}
</script>